export default {
  'app.console.nodata': 'ไม่มีข้อมูล',
  'app.console.recents': 'ล่าสุด',
  'app.console.recents.nodata': 'ไม่มีข้อมูลที่พร้อมใช้งาน กรุณาเปิดใช้งานบริการก่อน',
  'app.console.channel': 'บริการที่จะเปิดใช้งาน',
  'app.console.channel.active': 'บริการเปิดแล้ว',
  'app.console.channel.activateService': 'เริ่มต้นใช้งาน',
  'app.console.channel.learnMore': 'เรียนรู้เพิ่มเติม',
  'app.console.channel.sendNum': 'ส่ง',
  'app.console.channel.targetNum': 'เป้าหมาย',
  'app.console.channel.deliveredNum': 'จัดส่ง',
  'app.console.channel.clickNum': 'คลิก',
  'app.console.channel.readNum': 'อ่าน',
  'app.console.channel.sendNumRate': 'อัตราการส่ง',
  'app.console.channel.deliveredNumRate': 'อัตราการจัดส่ง',
  'app.console.channel.clickNumRate': 'อัตราส่วนคลิก',
  'app.console.channel.readNumRate': 'อัตราส่วนการอ่าน',
  'app.console.channel.title1': 'แนวโน้มใน 7 วันที่ผ่านมา',
  'app.console.channel.title2': 'แปลงใน 7 วันที่ผ่านมา',
  'app.console.channel.sendOut': 'ส่งข้อความ',
  'app.console.channel.start': 'เริ่มใช้งาน',
  'app.console.channel.message.activated': 'เปิดใช้งานแล้ว',
  'app.console.channel.message.apppush':
    'การรวม SDK เพื่อให้ได้การผสมผสานแบบอัจฉริยะและแม่นยำภายในเพียง 3 นาที เพื่อเพิ่มความเคลื่อนไหวและการรักษาความลูกค้า',
  'app.console.channel.message.email':
    'ให้บริการ API การส่งอีเมลที่มีประสิทธิภาพและเสถียร สนับสนุนการกำหนดค่า IP อิสระ การยืนยันตัวตน BIMI และการปรับกลยุทธ์การส่งเพื่อปรับปรุงอัตราการส่งผ่านข้อมูลย้อนกลับที่แม่นยำแบบเรียลไทม์',
  'app.console.channel.message.sms':
    'ฟังก์ชั่นการส่ง SMS ของเราผสมผสานบริการสื่อสารโทรศัพท์เคลื่อนที่แบบดั้งเดิมกับอินเทอร์เน็ต เพื่อช่วยให้ธุรกิจเป็นโลก',
  'app.console.channel.message.whatsapp':
    'ใช้ WhatsApp Business API เพื่อสร้างความสัมพันธ์ใกล้ชิดกับผู้ใช้รวมกว่า 2 พันล้านผู้ใช้ทั่วโลก',
  'app.console.channel.message.OTP':
    'EngageLab OTP ให้บริการสร้างและตรวจสอบรหัสผ่านชั่วคราวด้วยการส่งผ่านหลายช่องทาง เช่น WhatsApp、SMS、เสียง และอีเมล เพื่อให้การส่งถึงและการแปลงของคุณเป็นไปได้โดยสำเร็จ',
  'app.console.channel.message.webpush':
    'แทนที่จะพึ่งพาแอปบนมือถือ เราสามารถส่งข้อความการตลาดและการแจ้งเตือนบริการไปยังผู้ติดตามเว็บไซต์ได้ตลอดเวลาเพื่อเพิ่มประสิทธิภาพในการมีส่วนร่วมและการแปลงข้อมูลผู้ใช้',
  'app.console.channel.message.edm':
    'ติดตั้งได้ด้วยคลิกเดียวและไม่ต้องมีการเขียนโค้ด เว็บไซต์ของคุณสามารถดำเนินการตลาดทางอีเมconsole/en_US.tsลได้อย่างง่ายดายและใช้การอัตโนมัติเพื่อส่งเสริมให้ลูกค้าซื้อสินค้าและเพิ่มรายได้ได้',
  'app.console.channel.message.ma':
    'บริการการตลาดอัตโนมัติสนับสนุนการจัดการข้อมูลผู้ใช้ การสร้างเส้นทางของผู้ใช้ การเข้าถึงผู้ใช้ของคุณผ่านช่องทางหลายช่องทาง และมอบประสบการณ์',
  'app.console.channel.message.captcha':
    'CAPTCHA ของพฤติกรรม แก้ไขปัญหาการลบรายได้และความปลอดภัยที่เกิดจากการลักษณะของโปรแกรมคอมพิวเตอร์อัตโนมัติ',
  'app.console.channel.message.livedesk':
    'AI ขับเคลื่อนแพลตฟอร์มบริการลูกค้า ที่จัดการ 90% ของปัญหาลูกค้าได้อย่างสมบูรณ์',
  'app.console.channel.message.silentauth':
    'บริการการยืนยันตัวตนแบบเงียบ ให้โซลูชันการยืนยันตัวตนผู้ใช้ที่ปลอดภัยและราบรื่น',
  'app.console.channel.flag.email': 'การวิเคราะห์กล่องจดหมาย',
  'app.console.doc': 'เอกสาร REST API',
  'app.console.doc.apppush': 'เอกสาร AppPush',
  'app.console.doc.email': 'เอกสารอีเมล',
  'app.console.doc.sms': 'เอกสาร SMS',
  'app.console.doc.newsms': 'เอกสาร SMS',
  'app.console.doc.whatsapp': 'เอกสาร WhatsApp',
  'app.console.doc.webpush': 'เอกสาร WebPush',
  'app.console.doc.edm': 'เอกสาร EDM',
  'app.console.doc.otp': 'เอกสาร OTP',
  'app.console.doc.ma': 'เอกสาร Marketing Automation',
  'app.console.doc.captcha': 'เอกสาร CAPTCHA',
  'app.console.doc.livedesk': 'เอกสาร LiveDesk',
  'app.console.doc.silentauth': 'เอกสาร Silent Auth',
  'app.console.manage': 'การตั้งค่า',
  'app.console.manage.orders': 'คำสั่งซื้อและใบเรียกเก็บเงิน',
  'app.console.manage.pending': 'คำสั่งซื้อที่ต้องชำระเงิน',
  'app.console.manage.supplementary': 'ใบเรียกเก็บเงินที่ต้องชำระเงิน',
  'app.console.manage.notification': 'การแจ้งเตือน',
  'app.console.manage.faq': 'คำถามที่พบบ่อย',
  'app.console.manage.download': 'ดาวน์โหลด',
  'app.console.channel.verifiedRate': 'อัตราการยืนยัน',
  'app.console.channel.verifiedNum': 'จำนวนที่ยืนยัน',
  'app.console.channel.select.all': 'ทั้งหมด',
  'app.console.channel.requestCount': 'จำนวนคำขอ',
  'app.console.channel.successCount': 'จำนวนสำเร็จ',
  'app.console.channel.failCount': 'จำนวนล้มเหลว',
  'app.console.channel.successRate': 'อัตราความสำเร็จ',
  'app.console.channel.failRate': 'อัตราความล้มเหลว',
};
